import React, { useState, useEffect } from 'react';
import { isEmpty } from 'lodash';
import PropTypes from 'prop-types';
import AnnotationInit from 'chameleon/packages/blue-book-player/Annotation/AnnotationInit';
import NotesColumnInjector from 'chameleon/packages/blue-book-player/library/NotesColumn/NotesColumnInjector';

const HighlightsNotesWrapper = (props) => {
  const [learnosityItemReference, setLearnosityItemReference] = useState(null);
  const {
    learnosityApp,
    playerState,
    isStudentAccount,
    isQuestionDisplayed,
    subject,
  } = props;

  useEffect(() => {
    if (!learnosityApp || isEmpty(learnosityApp)) return;

    const onItemChanged = () => {
      const { reference } = learnosityApp?.getCurrentItem() || {};
      setLearnosityItemReference(reference);
    };

    learnosityApp?.on('item:changed', onItemChanged);

    return () => {
      learnosityApp?.off('item:changed', onItemChanged);
    };
  }, [learnosityApp]);

  return (
    <>
      <AnnotationInit
        learnosityApp={learnosityApp}
        learnosityItemReference={learnosityItemReference}
        isStudentAccount={isStudentAccount}
        subject={subject}
      />
      {isStudentAccount && (
        <NotesColumnInjector
          playerState={playerState}
          learnosityItemReference={learnosityItemReference}
          isQuestionDisplayed={isQuestionDisplayed}
        />
      )}
    </>
  );
};

HighlightsNotesWrapper.propTypes = {
  learnosityApp: PropTypes.object,
};

HighlightsNotesWrapper.defaultProps = {
  learnosityApp: {},
};

export default HighlightsNotesWrapper;
